const messages = {
  subtitle: "Meet Our Bridgestone team",
  title: "Contact",
  description: "Bine ai venit în zona de contact BRIDGESTONE PLUS.",
  teams: {
    direct: "Direct",
    indirect: "In Direct",
    tyre: "Echipa comerț anvelope",
    car: "Echipa dealeri auto",
    lkw: "Echipa camioane",
    em_otr: "Echipa EM/OTR",
    farm_tractor: "Echipa tractoare agricole",
    bandag: "Echipa Bandag",
    subtitle: "Meet Our Bridgestone team",
  },
  contact: {
    index: {
      title: "",
      description: "",
    },
    categories: {
      service: {
        description: "",
      },
      touch: {
        title: "",
        description: "",
      },
      contact: {
        short_desc: "",
      },
    },
    strategicPartners: {
      cardTitle: "",
      short_desc: "",
    },
  },
};

export default {
  messages,
};
